import { PaymentGateway } from '@laminar-product/client-commons-core/core';
import { Subscription } from 'types/subscription';

export const isSubscriptionFromGateway = (
  subscription?: Subscription,
  gateway?: PaymentGateway
) => (subscription ? subscription.gateway === gateway : false);
